import { blue } from "@mui/material/colors";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    data: null,
    error: false,
};


const route = "vidfleet/.components/configurationPreview/redux/slice";

export const saveVidfleetConfigurationPreview = createAsyncThunk("vidfleet/.components/configurationPreview/saveVidfleetConfigurationPreview", async (payload, { rejectWithValue, dispatch }) => {

    try {
        const { config, deviceId, devices, applyScopes, bulk, verificationCode } = payload
        let params = {}
        if (deviceId)
            params = {
                settings: JSON.stringify(config),
                scopes: ["Partial"],
                unitIds: [deviceId]
            }
        else
            params = {
                settings: JSON.stringify(config),
                scopes: ["Default"],
                unitIds: [],
                verificationCode: verificationCode
            }
       
        let response = await clientMutation(`
                mutation updateVidFleetAddConfig ($settings: AWSJSON!, $scopes: [enumVidFleetScope]!, $unitIds: [Int]!, $verificationCode: String) {
                result: updateVidFleetAddConfig (settings: $settings, scopes: $scopes, unitIds: $unitIds, verificationCode: $verificationCode)
            }`,
            params,
            endpoints.GRAPHQL_GENERAL
        )
        return { resolve: response?.result }

    } catch (exc) {
        // ALWAYS RETURN ACTION
        ExceptionManager(exc, route, 'saveVidfleetConfigurationPreview');
        return rejectWithValue(exc);
    }
}
)


export const configurationPreviewRedux = createSlice({
    name: 'vidfleet/configurationPreview/saveVidfleetConfigurationPreview',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalVidfleetConfigurationPreview(state, action) {
            state.openModal = true
            state.data = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(saveVidfleetConfigurationPreview.pending, (state, action) => {
            state.loading = true
        });

        builder.addCase(saveVidfleetConfigurationPreview.fulfilled, (state, action) => {
            state.result = action.payload
            state.loading = false;
        });

        builder.addCase(saveVidfleetConfigurationPreview.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        });
    }
})

const { actions, reducer } = configurationPreviewRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalVidfleetConfigurationPreview
} = actions;

export default reducer;
